<script setup>
import { ref } from 'vue';
import { usePipelineStore } from '../store/usePipeline';
const store = usePipelineStore();
const isOpen = ref(false); const rep = ref(null); const loading = ref(false);
const fmt = (v) => 'R$ ' + Number(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
const open = async () => { isOpen.value = true; loading.value = true; try { rep.value = await store.loadReport(); } finally { loading.value = false; } };
const close = () => { isOpen.value = false; };
const winRate = () => { if (!rep.value) return 0; const g = rep.value.ganhos.count, p = rep.value.perdidos.count; return (g + p) ? Math.round(g / (g + p) * 100) : 0; };
const maxCount = () => { if (!rep.value) return 1; return Math.max(1, ...rep.value.por_estagio.map((e) => e.count)); };
defineExpose({ open, close });
</script>

<template>
  <div v-if="isOpen" class="fixed inset-0 z-30 flex items-center justify-center bg-n-alpha-black1" @click.self="close">
    <div class="w-[560px] max-w-[94vw] bg-n-solid-2 rounded-xl outline outline-1 outline-n-container shadow-xl flex flex-col max-h-[88vh]">
      <div class="flex items-center justify-between px-4 h-12 border-b border-n-weak">
        <span class="font-medium text-sm text-n-slate-12">Relatorios do funil</span>
        <button class="text-n-slate-11 hover:text-n-slate-12 text-lg leading-none" @click="close">&times;</button>
      </div>
      <div class="p-4 overflow-y-auto">
        <div v-if="loading" class="text-n-slate-11 text-sm">Carregando...</div>
        <div v-else-if="rep" class="flex flex-col gap-4">
          <div class="grid grid-cols-4 gap-2">
            <div class="bg-n-solid-1 rounded-lg p-3 outline outline-1 outline-n-weak"><div class="text-xs text-n-slate-11">Aberto</div><div class="text-base font-semibold text-n-slate-12">{{ rep.aberto.count }}</div><div class="text-xs text-n-slate-10">{{ fmt(rep.aberto.valor) }}</div></div>
            <div class="bg-n-solid-1 rounded-lg p-3 outline outline-1 outline-n-weak"><div class="text-xs text-n-slate-11">Ganhos 30d</div><div class="text-base font-semibold text-n-slate-12">{{ rep.ganhos.count }}</div><div class="text-xs text-n-slate-10">{{ fmt(rep.ganhos.valor) }}</div></div>
            <div class="bg-n-solid-1 rounded-lg p-3 outline outline-1 outline-n-weak"><div class="text-xs text-n-slate-11">Win rate</div><div class="text-base font-semibold text-n-slate-12">{{ winRate() }}%</div><div class="text-xs text-n-slate-10">{{ rep.perdidos.count }} perdidos</div></div>
            <div class="bg-n-solid-1 rounded-lg p-3 outline outline-1 outline-n-weak"><div class="text-xs text-n-slate-11">Forecast</div><div class="text-base font-semibold text-n-slate-12">{{ fmt(rep.forecast) }}</div><div class="text-xs text-n-slate-10">ponderado</div></div>
          </div>
          <div>
            <div class="text-xs font-semibold text-n-slate-11 mb-2">Leads abertos por estagio</div>
            <div class="flex flex-col gap-1.5">
              <div v-for="e in rep.por_estagio" :key="e.stage_id" class="flex items-center gap-2">
                <span class="text-xs text-n-slate-11 w-24 shrink-0 truncate">{{ e.nome }}</span>
                <div class="flex-1 bg-n-solid-1 rounded h-4 overflow-hidden"><div class="h-full rounded" :style="{ width: (e.count / maxCount() * 100) + '%', background: e.cor }"></div></div>
                <span class="text-xs text-n-slate-12 w-24 text-right shrink-0">{{ e.count }} &middot; {{ fmt(e.valor) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
